import { Stripe } from "@stripe/stripe-js";
import { BillingData } from '../BillingTypes';
import { saveData } from "services/api/saveData";

export const handleManualPayment = async (
    stripe: Stripe | null,
    environmentHash: string,
    billingData: BillingData,
    subscriptionId: number,
    oldSubscriptionId?: number | null,
    newModuleLineIds?: number[] | null,
    removedModules?: string[] | null,
    newSeatLineIds?: number[] | null,
    apiTokenId?: number | null,
    returnPath?: string | null,
) => {

    // Throw if stripe is not initialized
    if (!stripe) {
        throw new Error("Stripe is not initialized");
    }

    // Check if the company name is given
    const { company_name } = billingData;
    if (!company_name) {
        throw new Error("No company name is set.");
    }

    // Create the payment intent in the backend
    const paymentResponse = await saveData({
        apiUrl: `handle_manual_payment/${environmentHash}`,
        method: "post",
        data: {
            subscription_id: subscriptionId,
            old_subscription_id: oldSubscriptionId,
            new_module_line_ids: newModuleLineIds,
            removed_modules: removedModules,
            new_seat_line_ids: newSeatLineIds,
            api_token_id: apiTokenId
        }
    });

    // Throw when the payment intent could not be created
    if (paymentResponse?.status !== 200) {
        throw new Error("Failed to create payment intent");
    }

    // Build the return url with the optional return path for the thank you page
    const returnUrl = returnPath
        ? `${window.location.origin}/settings/billing/subscription/thank-you?return_to=${encodeURIComponent(returnPath)}`
        : `${window.location.origin}/settings/billing/subscription/thank-you`;

    // Confirm ideal payment
    await stripe.confirmIdealPayment(paymentResponse.data.client_secret, {
        payment_method: {
            ideal: {},
            billing_details: {
                name: billingData.company_name!,
            },
        },
        return_url: returnUrl
    });
};
